import {createStrokeSVG} from './TEMPLATE'

// lucide: eye
export const Eye_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0',
    'M9 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0Z',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
